import { Component } from "@angular/core";
import { LegalPageComponent } from "../legal-page/legal-page.component";
import { PAYMENT_PROMOTION } from "../data/payment-and-promotion.data";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-payment-promotion-policy",
  imports: [LegalPageComponent],
  templateUrl: "./payment-promotion-policy.component.html",
})
export class PaymentPromotionPolicyComponent {
  sections = PAYMENT_PROMOTION;

  appName = environment.appName

  introKey = `<p class="mb-2">นโยบายการชำระเงินและโปรโมชั่นฉบับนี้จัดทำขึ้นเพื่อกำหนดหลักเกณฑ์เกี่ยวกับการสั่งซื้อคอร์สเรียน
                    การชำระเงิน ราคา ส่วนลด โปรโมชั่น และสิทธิประโยชน์ต่าง ๆ บน <span class="text-primary fw-bold">${this.appName || 'Wise'}</span></p>`
}
